import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

// Create (POST)
export const getAllCategories = createAsyncThunk('get all categories', async () => {
  const response = await $axios.get('/categories');
  return response.data;
});

// Read (GET)
export const createCategory = createAsyncThunk('create category / sub-category data', async (payload) => {
  let response = [null, null];
  try {
    const res =
      payload.type === 'category'
        ? await $axios.post('/categories', payload.data)
        : await $axios.post(`/categories/${payload.parent}/sub-category`, payload.data);

    response = [res.data.data, null];
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

// GET Single Category
export const getCategoryData = createAsyncThunk('get category / sub-category data', async (id) => {
  let response = [null, null];
  try {
    const res = await $axios.get(`/categories/${id}`);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

// Update (PUT or PATCH)
export const updateCategoryData = createAsyncThunk('update category / sub-category data', async ({ id, updatedData }) => {
  let response = [null, null];
  try {
    const res = await $axios.put(`/categories/${id}`, updatedData);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

// Delete (DELETE)
export const deleteCategoryData = createAsyncThunk('delete category / sub-category data', async (id) => {
  let response = [null, null];
  try {
    const res = await $axios.delete(`/categories/${id}`);
    response = [res.data, null];
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

export const resetAllDataCats = createAsyncThunk('reset all data cats', async () => {
  return 'reset all data cats';
});

// Slice
const categorySlice = createSlice({
  name: 'categorySlice',
  initialState: {
    categories: [],
    singleCategory: null,
    updatedCategory: null,
    catDeleted: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Get all categories
    builder
      .addCase(getAllCategories.pending, (state) => {
        state.categories = [];
      })
      .addCase(getAllCategories.fulfilled, (state, action) => {
        state.categories = action.payload?.data ? action.payload.data : [];
      });

    // Update Single Category
    builder
      .addCase(updateCategoryData.pending, (state) => {
        state.updatedCategory = null;
      })
      .addCase(updateCategoryData.fulfilled, (state, action) => {
        state.updatedCategory = action.payload;
      });

    // Get Single Category
    builder
      .addCase(getCategoryData.pending, (state) => {
        state.singleCategory = null;
      })
      .addCase(getCategoryData.fulfilled, (state, action) => {
        state.singleCategory = action.payload;
      });

    // Create Data
    builder
      .addCase(createCategory.pending, (state) => {
        state.singleCategory = null;
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        state.singleCategory = action.payload;
      });

    // Delete Data
    builder
      .addCase(deleteCategoryData.pending, (state) => {
        state.catDeleted = false;
      })
      .addCase(deleteCategoryData.fulfilled, (state, action) => {
        if (action.payload && action.payload[0]) {
          state.catDeleted = true;
        }
      });

    builder.addCase(resetAllDataCats.fulfilled, (state) => {
      state.categories = [];
      state.singleCategory = null;
      state.updatedCategory = null;
      state.catDeleted = false;
    });
  },
});

export default categorySlice.reducer;
